import Swal from 'sweetalert2'

/**
 * ConfirmToast function will display a sweet alert prompting the user to confirm their decision
 * @param {Object} msg object which consists of title and text
 */
// export const ConfirmToast = async (msg) => {
//   const { value, dismiss } = await Swal.fire({
//     title: msg,
//     icon: 'question',
//     showCancelButton: true,
//     cancelButtonText: 'Quit',
//     cancelButtonColor: '#97b557',
//     confirmButtonText: 'Confirm'
//   })
//   if (value) {
//     return true
//   } else if (dismiss) {
//     return false
//   }
// }

/**
 * Pops uo toast for confirmation
 * @async
 * @param {Object} msg - message text and title
 * @param {string} msg.msg - message title
 * @param {string} msg.txt - message text
 * @returns {Boolean}
 */
const ConfirmToast = async (msg) => {
  const { value, dismiss } = await Swal.fire({
    title: msg.msg,
    text: msg.txt ? msg.txt : '',
    icon: 'question',
    showCancelButton: true,
    cancelButtonText: 'Quit',
    cancelButtonColor: '#97b557',
    confirmButtonText: 'Confirm'
  })
  if (value) {
    return true
  } else if (dismiss) {
    return false
  }
}

export default ConfirmToast
